export default "__VITE_ASSET__1b906fb0__"